import { useContext } from 'react';

import { AssetTooltipContext } from '../providers/asset-tooltip';

export function useAssetTooltip() {
  return useContext(AssetTooltipContext);
}
